import {
	DeleteHealthAppointments,
	DeleteHealthAppointmentsModel,
	DeleteHealthAppointmentsParams,
} from 'domain/usecases';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

export class RemoteDeleteHealthAppointments implements DeleteHealthAppointments {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<DeleteHealthAppointmentsModel>,
	) {}

	async delete(params: DeleteHealthAppointmentsParams): Promise<DeleteHealthAppointmentsModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'delete',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
